import styles from "./index.module.scss"

interface SeparatorProps {
  desc: string
}

export const Separator = (props: SeparatorProps) => {
  return (
    <div className={styles.Separator}>
      <div className={styles.Line}/>
      <div>{props.desc}</div>
      <div className={styles.Line}/>
    </div>
  )
}
